import styled from 'styled-components';

export const $InlineField = styled.div`
  margin-bottom: 0.5rem;
  min-width: 0;
  line-height: 1.35;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const $InlineFieldLabel = styled.span`
  color: ${({ theme }) => theme.newUI?.defaultColors?.secondaryText ?? '#64748b'};
  font-size: ${({ theme }) => theme.fonts.size.ultraSmall};
  font-weight: ${({ theme }) => theme.fonts.weight.mediumFont ?? 500};

  &::after {
    content: ':';
    margin-right: 0.35rem;
  }
`;

export const $InlineFieldValue = styled.span`
  color: ${({ theme }) => theme.newUI?.defaultColors?.text ?? theme.colors.mainTextColor};
  font-size: ${({ theme }) => theme.fonts.size.small};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
`;

export const $ResponsiveFileSection = styled.div`
  width: 100%;
  margin-bottom: 0.75rem;
`;

export const $SectionTitle = styled.div`
  color: ${({ theme }) => theme.newUI?.defaultColors?.text ?? theme.colors.mainTextColor};
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 0.35rem;
`;

export const $CarouselViewport = styled.div`
  overflow: hidden;
  width: 100%;
`;

export const $CarouselTrack = styled.div`
  display: flex;
  touch-action: pan-y pinch-zoom;
`;

export const $CarouselSlide = styled.div`
  flex: 0 0 88%;
  min-width: 0;
  padding-right: 0.75rem;
  box-sizing: border-box;
`;

export const $CarouselCard = styled.div`
  box-sizing: border-box;
  min-height: 100%;
  padding: 0.9rem 1rem;
  border-radius: ${({ theme }) => theme.newUI?.borders?.bigRadius ?? '12px'};
  border: 1px solid ${({ theme }) => theme.newUI?.inputBorderColors?.default ?? '#e5e7eb'};
  background: ${({ theme }) =>
    theme.newUI?.variationColors?.light5 ?? theme.systemColors?.defaultBackground ?? '#fff'};
`;

export const $CarouselDots = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.4rem;
  margin-top: 0.75rem;
`;

export const $CarouselDot = styled.button<{ $isActive: boolean }>`
  width: ${({ $isActive }) => ($isActive ? '1rem' : '0.4rem')};
  height: 0.4rem;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: ${({ theme, $isActive }) =>
    $isActive
      ? (theme.colors?.primary ?? '#5369eb')
      : (theme.newUI?.variationColors?.light3 ?? '#cbd5e1')};
  cursor: pointer;
  transition:
    width 0.15s ease,
    background-color 0.15s ease;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors?.primary ?? '#5369eb'};
    outline-offset: 2px;
  }
`;
